<template>
  <div ref="app" id="app" :class="[globalTheme]">
    <div v-if="isProfilePage">
      <Toaster />
      <router-view></router-view>
    </div>
    <div v-else>
      <div
        v-if="isTFW && isShowContent && !isCandidate"
        class="c-app tfw overflow-auto"
        :class="[getOrgThemeStyle, addNewClass]"
      >
        <NewHeader @scrollToSection="handleScrollToSection" />
        <!-- <TFWHeader class="header-bar" /> -->
        <LoadingOverlay v-if="isLoading" />
        <router-view ref="mainContent"></router-view>
        <Toaster />
        <ChatWidget/>
        <FixedToaster />
        <CookieConsent />
      </div>
      <div
        v-else-if="isShowContent && !isTFWHost"
        class="c-app"
        :class="[getOrgThemeStyle, addNewClass]"
      >
        <TheHeader class="header-bar" />
        <!-- <div ref="cbody" id="c-body-app" class="c-body"> -->
        <LoadingOverlay v-if="isLoading" />
        <Toaster />
        <FixedToaster />
        <EaseAccess />
        <SessionTimeout />
        <ChatWidget/>
        <div>
          <Split ref="split1" :style="isSplitView ? 'height: calc(100vh)' : ''">
            <SplitArea :size="isSplitView ? 50 : 100">
              <div>
                <div id="leftPane">
                  <router-view></router-view>
                </div>
              </div>
            </SplitArea>
            <SplitArea :size="50">
              <div v-if="isSplitView">
                <div id="rightPane"></div>
              </div>
            </SplitArea>
          </Split>
        </div>

        <!-- </div> -->
        <TheFooter></TheFooter>
      </div>
      <div
        v-else-if="isShowContent && isTFWHost"
        class="c-app tfw overflow-auto"
        :class="`${getOrgThemeStyle}`"
      >
        <TFWHeader class="header-bar" />
        <div class="c-wrapper">
          <div class="c-body">
            <main class="c-main">
              <div class="container-fluid">
                <LandingPage />
              </div>
            </main>
          </div>
        </div>
        <Toaster />
        <FixedToaster />
        <ChatWidget />
      </div>
    </div>
    <CustomModal
      theme="tfm-primary"
      :centered="true"
      :closeOnBackdropClick="false"
      :isShowPopup="activeSessionModal.isShowPopup"
      :modalTitle="activeSessionModal.modalTitle"
      :modalContent="activeSessionModal.modalContent"
      :buttons="activeSessionModal.buttons"
      @modalCallBack="checkAuthTokenExist"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Toaster from "@/components/reusable/Toaster";
import FixedToaster from "@/components/reusable/FixedToaster";
import TheHeader from "@/containers/TheHeader";
import EaseAccess from "@/containers/EaseAccess/EaseAccess";
import SessionTimeout from "@/containers/SessionTimeout";
import TheFooter from "@/containers/TheFooter";
import { TFW_HOST_URL } from "@/service_urls";
import Modal from "./components/reusable/Modal.vue";
import CustomModal from "@/components/reusable/CustomModal.vue";
import CookieConsent from "@/components/reusable/CookieConsent.vue";

//TFW
import TFWHeader from "@/pages/TFW/TFWHeader";
import LandingPage from "@/pages/TFW/LandingPage/LandingPage.vue";

// Website/landing Pages
import NewHeader from "../src/containers/STM/NewHeader.vue";
import NewFooter from "../src/containers/STM/NewFooter.vue";
import HomeView from "../src/containers/STM//HomeView";

// ChatBot
import ChatWidget from "@/components/ChatBot/ChatWidget.vue";

export default {
  name: "App",
  components: {
    Toaster,
    FixedToaster,
    TheHeader,
    TheFooter,
    EaseAccess,
    SessionTimeout,
    //------TFW Components------//
    TFWHeader,
    LandingPage,
    NewHeader,
    NewFooter,
    HomeView,
    Modal,
    CustomModal,
    CookieConsent,
    ChatWidget,
  },
  data() {
    return {
      isSplitView: false,
      activeSessionModal: {
        isShowPopup: false,
        modalTitle: "｡°⚠︎°｡ Notification",
        modalContent: "You’ve been logged out. Select continue to log back in.",
        buttons: [
          { label: "No", type: "secondary" },
          { label: "Continue", type: "tfw_primary" },
        ],
      },
      addNewClass: "",
    };
  },
  computed: {
    ...mapGetters([
      "scrollTop",
      "isLoading",
      "getOrgThemeStyle",
      "isShowContent",
      "isAuthTokenExist",
      "isSuperCustomer",
      "getRoleScopes",
      "isLoggedIn",
    ]),
    isTFW() {
      return this.$route?.path.includes("/tfm") || false;
    },
    isTFWHost() {
      const currentURL =
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "");
      return currentURL === TFW_HOST_URL;
    },
    isProfilePage() {
      return this.$route?.path.includes("/view/profile-page") || false;
    },
    isCandidate() {
      return (
        this.getRoleScopes.length &&
        (this.getRoleScopes[0] === "customer_candidate" ||
          this.getRoleScopes[0] === "system_candidate")
      );
    },
    addTheme() {
      return !!(this.isSuperCustomer || this.isCandidate);
    },
    globalTheme() {
      return this.addTheme ? "theme_gradient" : "";
    },
  },
  methods: {
    ...mapActions(["logout"]),
    handleScrollToSection(sectionId) {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    handleKeyDown(event) {
      // Check if Ctrl+Shift+H is pressed
      if (event.ctrlKey && event.shiftKey && event.key === "H") {
        event.preventDefault(); // Prevent the default browser behavior (e.g., save page)

        this.isSplitView = !this.isSplitView;
        if (this.isSplitView) {
          this.clonePage();
        }
      }
    },
    clonePage() {
      setTimeout(() => {
        const leftPane = document.getElementById("leftPane");
        const rightPane = document.getElementById("rightPane");

        // Clone the HTML content
        const clonedContent = leftPane.cloneNode(true);

        // Clear existing content in the right pane
        rightPane.innerHTML = "";

        // Append the cloned content to the right pane
        rightPane.appendChild(clonedContent);
      }, 100);
    },
    async checkAuthTokenExist(action) {
      if (action === "Continue") {
        await this.logout();
      }
      this.activeSessionModal.isShowPopup = false;
      this.$store.commit("SET_ACTIVE_SESSION_MODAL", false);
    },
    updateThemeClass(path) {
      const classes = [];

      if (path.includes("/public/job-board/")) {
        classes.push("theme_gradient");
      }

      this.addNewClass = classes.join(" ");
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeyDown);
    document.body.style.overflow = "auto";
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  watch: {
    scrollTop() {
      if (this.scrollTop) {
        const app = this.$refs.app;
        if (app) app.scrollTo(0, 0);
      }
    },
    isAuthTokenExist: {
      handler(newVal) {
        this.activeSessionModal.isShowPopup = newVal;
      },
      immediate: true,
    },
    $route: {
      immediate: true,
      handler(to) {
        this.updateThemeClass(to.path);
      },
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";

.split-container {
  display: flex;
  width: 100%;
}

.left-pane,
.right-pane {
  height: 100%;
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
}

.right-pane {
  width: 100%;
}

// .splitter {
//   width: 8px;

//   height: 100%;
//     float: left;

//     cursor: col-resize;
//     background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==);

//     background-color: #eee;
//     background-repeat: no-repeat;
//     background-position: 50%;
// }
</style>
